/** 
 * @type {import("./defs").StoreTransactionRequest} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreTransactionRequest} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreTransactionRequest.js